import { HoardOrder, SaleOrder } from '../../sales'
import { usePriceOutlineHooks } from '../../operations'
import { TableName } from '../../../tables'

// Total real de cada operación (con ajuste de lista, descuentos, recargo del medio de pago, IVA y percepciones),
// el mismo que usan el detalle de la operación y la Lista de Deudores
export const useOperationTotals = () => {
    const { getPriceOutline } = usePriceOutlineHooks()

    const getTotal = (table: TableName, operation: SaleOrder | HoardOrder): number => {
        try {
            return getPriceOutline(table, operation).total
        } catch (e) {
            // Pasa si algún producto de la operación no tiene precios cargados (ej. producto eliminado)
            console.warn(`Dashboard: no se pudo calcular el total de la operación #${operation.code}`, e)
            return 0
        }
    }

    const getSaleTotal = (sale: SaleOrder) => getTotal(TableName.SALE_ORDERS, sale)

    const getHoardTotal = (hoard: HoardOrder) => getTotal(TableName.HOARD_ORDERS, hoard)

    return {
        getSaleTotal,
        getHoardTotal
    }
}
